export enum MessageBoxResult {
   no = 0,
   yes = 1
};
